module.exports = __webpack_public_path__ + "media/images/workplace/welcome_bg/3-5e2458a5a928be3e71dc75155d86a097.jpg";